import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocumentsList = function (props) {
    var listItemTemplate = props.listItemTemplate, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents-list", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "list-item-template": listItemTemplate ? (typeof listItemTemplate === 'string' ? listItemTemplate : JSON.stringify(listItemTemplate)) : undefined }, children));
};
export default VeltNotificationsPanelContentDocumentsList;
